import React, { useState, useEffect } from "react";
import PolicyDetails from "../common/PolicyDetails";

// A component to render multiple policies for renewal
const RenewalPoliciesView = ({ policies, onReupload, onPolicySelect }) => {
  const [selectedPolicy, setSelectedPolicy] = useState(null);

  const handlePolicySelect = (policy) => {
    setSelectedPolicy(policy);
    // Call the callback to inform parent component
    onPolicySelect(policy);
  };

  // Automatically select the policy if there's only one
  useEffect(() => {
    if (policies.length === 1) {
      handlePolicySelect(policies[0]);
    }
  }, [policies]);

  return (
    <div className="space-y-6 p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Your Verified Policy
        </h1>
        <p className="text-gray-600 mb-4">
          We already have your active policy on file. Select it to continue.
        </p>
      </div>

      <p className="text-sm text-gray-700 bg-gray-50 p-3 rounded-lg mb-4">
        These are your verified Insurance Declarations. Carefully review the details before proceeding.
      </p>

      {policies.length === 0 ? (
        <div className="text-center text-gray-600 bg-gray-50 p-6 rounded-lg">
          <p className="text-lg font-semibold mb-2">No Verified Policies Found</p>
          <p>We couldn't locate any active insurance policies in our system.</p>
          <button 
            onClick={onReupload} 
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
          >
            Upload Policy Document
          </button>
        </div>
      ) : (
        policies.map((policy, index) => (
          <div
            key={policy.id || index}
            className={`border rounded-lg shadow-sm cursor-pointer transition-all ${
              selectedPolicy?.id === policy.id ? "border-blue-500 bg-blue-50 ring-2 ring-blue-300" : "hover:border-blue-300"
            }`}
            onClick={() => handlePolicySelect(policy)}
          >
            <PolicyDetails policy={policy} onReupload={onReupload} />
          </div>
        ))
      )}
    </div>
  );
};

export default RenewalPoliciesView;